import React from "../../js/libs/react/react-polyfill";
import EmptyForm from "./components/EmptyForm";

import "./FormPanel.css";
import "./components/minigames.css";

let components = {};
let importComponentsPromise = (() => import("./components/").then(
  module => { components = module.default;})
)();

function EmptyFormPanel() {
  return React.createElement(EmptyForm, {});
}

/**
 * FormPanel is a component that represents `form` object
 * There are two properties `form` and `handler`.
 * `form` is an object with a string type specifying a way to represent it.
 * If `components` has a key `form.type`, a form is displayed
 *   with `components[msg.type]` with the same `props` object.
 * If no component is specified by `components`, "./components/Type" is loaded,
 *   where "Type" is a string value `form.type` with first letter capitalized.
 * When a component is loaded successfully, FormPanel rerenders.
 * `state.Component` is used to transfer loaded component.
 * The second property `handler` is a callback processing chosen parameter.
 * Note that a domain (a set of possible arguments) of `handler` must be
 *   consistent with the given form.
 */
var FormPanel = React.createFactory(React.createClass({
  
  displayName: "FormPanel",
  
  getInitialState: function(){
    return {
      componentsLoaded : false
    }
  },

  componentWillMount: function(){
    importComponentsPromise.then(
      () => {this.setState({componentsLoaded: true})}
    )
  },

  getDefaultProps: function() {
    return {
      form: undefined,
      handler: undefined
    };
  },

  render: function() {
    var form = this.props.form;
    if(!form || !this.state.componentsLoaded) return EmptyFormPanel();
    if(form.type === undefined) {
      console.error("form type missing");
      return EmptyFormPanel();
    }
    var Component = components[form.type];
    if(Component === undefined) {
        console.error("unknown form type " + form.type + ".");
        return EmptyFormPanel();
    }
    // var Suspense = React.Suspense;
		// return <Suspense fallback={<div>...</div>}><Component {...this.props} /></Suspense>;
    return <Component {...this.props} />;
  }
  
}));

FormPanel.components = components;

export default FormPanel;
